/**
 * @generated SignedSource<<f77168a7950dade9186447c1e85b885e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PageWithBreadCrumbs_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BreadCrumbsHeader_query">;
  readonly " $fragmentType": "PageWithBreadCrumbs_query";
};
export type PageWithBreadCrumbs_query$key = {
  readonly " $data"?: PageWithBreadCrumbs_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageWithBreadCrumbs_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageWithBreadCrumbs_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BreadCrumbsHeader_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "5af228d47e7b1f230ad877a2c3e8ac96";

export default node;
